import { PilotDoc, PilotDocRaw } from '../../../types';

export function parseDocumentDates(doc: PilotDocRaw): PilotDoc {
  return {
    ...doc,
    startDate: doc.startDate ? new Date(`${doc.startDate}T00:00`) : undefined,
    endDate: doc.endDate ? new Date(`${doc.endDate}T00:00`) : undefined,
  };
}
